import { Expose } from 'class-transformer'

export class TopPageViewType {
  @Expose() name: string

  @Expose({ name: 'view' })
  value: number
}
